<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <b-row>
      <b-col cols="12">
        <b-card class="">
          <h4 class="text-primary">
            <feather-icon icon="PlusSquareIcon" size="20"/>
            افزودن اسلاید
          </h4>

          <b-row>
            <b-media class="my-2 col-12 col-md-4">
              <validation-observer
                  ref="refFormObserver"
              >
                <b-form-group
                    label="لینک اسلاید"
                    label-for="blog-content"
                    class="mb-2"
                >
                  <validation-provider
                      #default="{ errors }"
                      rules="required"
                  >
                    <b-form-input
                        dir="ltr"
                        id="blog-content"
                        rows="4"
                        v-model="newSlide.Link"
                        :state="errors.length > 0 ? false:null"
                    ></b-form-input>
                  </validation-provider>
                </b-form-group>

                <!--                <b-form-group-->
                <!--                    label="لینک اسلاید"-->
                <!--                    label-for="blog-content"-->
                <!--                    class="mb-2"-->
                <!--                >-->
                <!--                  <validation-provider-->
                <!--                      #default="{ errors }"-->
                <!--                      rules="required"-->
                <!--                  >-->
                <!--                    <b-form-input-->
                <!--                        id="blog-content"-->
                <!--                        rows="4"-->
                <!--                        v-model="newSponsor.link"-->
                <!--                        :state="errors.length > 0 ? false:null"-->
                <!--                    ></b-form-input>-->
                <!--                  </validation-provider>-->
                <!--                </b-form-group>-->

                <template>
                  <p class="mb-1">تصویر اسلاید</p>
                  <b-avatar
                      class="cursor-pointer w-100"
                      ref="previewEl"
                      :src="base64ImageSrc"
                      size="300px"
                      rounded
                      @click.native="$refs.refInputEl.click()"
                  >
                    <feather-icon v-if="base64ImageSrc === null" icon="PlusSquareIcon" size="100"/>
                  </b-avatar>
                </template>
                <b-button
                    variant="warning"
                    @click="$refs.refInputEl.click()"
                    class="mt-2 mb-sm-0 mr-2 col-12 col-md-5 d-none"
                >
                  <input
                      ref="refInputEl"
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      class="d-none"
                      @input="uploadMedia"
                  >
                </b-button>

                <!--                <b-button-->
                <!--                    variant="primary"-->
                <!--                    class="mt-2 mb-sm-0 mr-0 col-12 col-md-5"-->
                <!--                    :block="$store.getters['app/currentBreakPoint'] === 'xs'"-->
                <!--                    @click="setData"-->
                <!--                >-->
                <!--                  ثبت-->
                <!--                </b-button>-->
              </validation-observer>
            </b-media>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="pageData.length > 0">
      <b-col cols="12">
        <b-card no-body>
          <h4 class="m-2 ">لیست اسلاید‌ها</h4>

          <b-table
              ref="refUserListTable"
              class="position-relative"
              :items="pageData"
              responsive
              :sort-by.sync="sortBy"
              :fields="myTableColumns"
              primary-key="id"
              show-empty
              bordered
              striped
              empty-text="موردی موجود نیست!"
          >

            <template #cell(image)="data">
              <b-avatar size="100" square :src="baseUrl+data.item.image"/>
            </template>

            <template #cell(operation)="data">
              <div class="d-flex align-items-center justify-content-start">
                <div class="cursor-pointer d-flex flex-row mx-1"
                     v-b-modal.modal-delete
                     @click="selectedToDelete = JSON.parse(JSON.stringify(data.item.id))"
                >
                  <feather-icon icon="TrashIcon" size="20" class="text-danger"/>
                </div>
              </div>
            </template>
          </b-table>

        </b-card>
      </b-col>
    </b-row>

    <b-modal
        id="modal-delete"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="deleteData()"
    >
      <span>حذف شود؟</span>
    </b-modal>

  </b-overlay>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BImg,
  BCardText,
  BLink,
  BButton,
  BDropdown,
  BDropdownItem,
  BAlert,
  BTab,
  BTabs,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BMedia,
  BAvatar,
  BOverlay, BTable, BPagination, BBadge, BModal,
} from 'bootstrap-vue'
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {MediaCreateFileRequest} from "@/libs/Api/Media";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import Helper from "@/libs/Helper";
import {BlogCreateBlogRequest} from "@/libs/Api/Blog";
import {required} from '@validations';
import {SlideCreateSlideRequest, SlideDeleteSlideRequest, SlideGetSlidesRequest} from "@/libs/Api/Slide";

export default {
  title: 'اسلایدهای صفحه اصلی - پنل ادمین بنفشه باقری',
  data() {
    return {
      required,
      overlay: false,
      baseUrl:Helper.baseUrl,
      pageData: [],
      base64ImageSrc: null,
      newSlide:{
        File:null,
        AltText:'',
        Link:'',
        Type:1,
      },
      newSponsor: {
        id: null,
        title: null,
        picUrl: null,
        link: null,
        isActive: true,
      },
      perPageOptions: [10, 20, 30, 40, 50],
      currentPage: 1,
      sortBy: '',
      count: 10,
      totalCount: null,
      selectedToDelete: null,
      selectedToEdit: {},
      myTableColumns: [
        {
          key: 'image',
          label: 'تصویر اسلاید',
        },
        {
          key: 'link',
          label: 'لینک اسلاید',
        },
        {
          key: 'operation',
          label: 'عملیات'
        },
      ],
    }
  },
  async created() {
    await this.getData();
  },
  watch: {
    currentPage: function (nv, ov) {
      this.getData();
    },
    count: function (nv, ov) {
      this.getData();
    },
  },
  methods: {
    async getData() {
      let _this = this;
      _this.overlay = true;

      let data = {
        type:2,
      }

      let sponsorGetAllRequest = new SlideGetSlidesRequest(_this);
      sponsorGetAllRequest.setParams(data);
      await sponsorGetAllRequest.fetch(function (content) {
        _this.overlay = false;
        _this.pageData = content.data;
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    async uploadMedia() {
      let _this = this;
      Helper.validateForm(_this, 'refFormObserver', async () => {
        _this.overlay = true;
        let formData = new FormData;
        let upFile = _this.$refs.refInputEl.files[0];
        formData.append('file', upFile);
        formData.append('link', _this.newSlide.Link);
        formData.append('type', 2);
        let createFile = new SlideCreateSlideRequest(_this);
        createFile.setData(formData);
        await createFile.sendFormData((content) => {
          _this.overlay = false;
          window.location.reload();
        }, (error) => {});
      })
    },
    async uploadMediaForUpdate() {
      let _this = this;
      _this.overlay = true;
      let formData = new FormData;
      let upFile = document.getElementById(_this.selectedToEdit.id).files[0];
      formData.append('uploadFile', upFile);
      formData.append('type', 2);
      let createFile = new MediaCreateFileRequest(_this);
      createFile.setParams(formData);
      await createFile.sendFormData((content) => {
        _this.overlay = false;
        _this.selectedToEdit.picUrl = content.value;
      }, (error) => {
        _this.overlay = false;
        console.log(error)
      });
    },
    async updateData() {
      let _this = this;
      if (_this.selectedToEdit.title.length < 1) {
        return _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            variant: 'danger',
            text: `عنوان اسلاید الزامی است.`,
          },
        })
      }
      if (_this.selectedToEdit.link.length < 1) {
        return _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            variant: 'danger',
            text: `لینک اسلاید الزامی است.`,
          },
        })
      }
      _this.showOverlay = true;
      let sponsorUpdateRequest = new SponsorUpdateRequest(_this);
      sponsorUpdateRequest.setParams(_this.selectedToEdit);
      await sponsorUpdateRequest.fetch(function (content) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `اسلاید ویرایش شد.`,
          },
        })
        _this.showOverlay = false;
        _this.selectedToEdit = {};
        _this.getData();
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    async setData() {
      let _this = this;

      if (_this.newSponsor.cover === null) {
        return _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            variant: 'danger',
            text: `لوگو اسلاید الزامی است.`,
          },
        })
      }

      Helper.validateForm(_this, 'refFormObserver', async () => {
        _this.showOverlay = true;

        let sponsorCreateRequest = new SponsorCreateRequest(_this);
        sponsorCreateRequest.setParams(_this.newSponsor);
        await sponsorCreateRequest.fetch(function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `اسلاید ساخته شد.`,
            },
          })
          _this.showOverlay = false;
          _this.base64ImageSrc = null;
          _this.newSponsor = {
            id: null,
            title: null,
            picUrl: null,
            link: null,
            isActive: true,
          }
          _this.getData();
        }, function (error) {
          _this.showOverlay = false;
          console.log(error)
        })
      })
    },
    async deleteData() {
      let _this = this;
      _this.overlay = true;

      let sponsorDeleteRequest = new SlideDeleteSlideRequest(_this);
      sponsorDeleteRequest.setParams(_this.selectedToDelete);
      await sponsorDeleteRequest.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        _this.selectedToDelete = null;
        _this.getData();
      }, function (error) {
        _this.overlay = false;
        console.log(error)
      })
    },
    clickOnInput(id) {
      let input = document.getElementById(id);
      input.click();
    }
  },
  components: {
    BModal,
    BBadge, BPagination, BTable,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BAlert,
    BTab,
    BTabs,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BMedia,
    BAvatar,
    BOverlay,
    vSelect,
    ValidationObserver, ValidationProvider,
  },
}
</script>

<style scoped>

</style>
